module.exports = {
    prefix: 'tw-',
    purge: [
        './resources/**/*.html',
        './resources/**/*.vue',
        './resources/**/*.js',
        './resources/**/*.scss',
        './resources/**/*.php',

        './packages/lav-galaxy/framework/resources/**/*.html',
        './packages/lav-galaxy/framework/resources/**/*.vue',
        './packages/lav-galaxy/framework/resources/**/*.js',
        './packages/lav-galaxy/framework/resources/**/*.scss',
        './packages/lav-galaxy/framework/resources/**/*.php',
    ],
    theme: {
        extend: {
            /*
            animation: {
                'slide-from-left': 'slideFromLeft 1.5s ease',
                'slideFromRight': 'slideFromRight 1.5s ease',
                'slideFromTop': 'slideFromTop 1.5s ease',
                'slideFromBottom': 'slideFromBottom 1.5s ease',
            },
            */
            backgroundOpacity: {
                '6': '0.06',
                '15': '0.15',
                '35': '0.35',
            },
            colors: {
                palette: {
                    blue: '#348dd7',
                    darkblue: '#25407C',
                    green: '#A5C341',
                    purple: '#aa76b1',
                    red: '#CB2F33',
                    orange: '#ED8D2E',
                    lightblue: '#0785E2',
                    lightgray: '#7C7C7C',
                    pink: '#CB4688',
                }
            },
            boxShadow: {
                soft: '0 0 20px 0 rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            },
            /*
            keyframes: {
                'slideFromLeft': {
                    '0%': { transform: 'translateX(-100%)' },
                    '100%': { transform: 'translateX(0)' },
                },
                'slideFromRight': {
                    '0%': { transform: 'translateX(100%)' },
                    '100%': { transform: 'translateX(0)' },
                },
                'slideFromTop': {
                    '0%': { transform: 'translateY(-100%)' },
                    '100%': { transform: 'translateY(0)' },
                },
                'slideFromBottom': {
                    '0%': { transform: 'translateY(100%)' },
                    '100%': { transform: 'translateY(0)' },
                },
            },
            */
            minHeight: {
                '1': '0.5em',
                '2': '1em',
                '3': '1.5em',
                '4': '2em',
                '5': '2.5em',
                '6': '3em',
                '7': '3.5em',
                '8': '4em',
                '9': '4.5em',
                '10': '5em',
                '11': '5.5em',
                '12': '6em',
                '13': '6.5em',
                '14': '7em',
                '15': '7.5em',
                '16': '8em',
                '17': '8.5em',
                '18': '9em',
                '19': '9.5em',
                '20': '10em',
                '21': '10.5em',
                '22': '11em',
                '23': '11.5em',
                '24': '12em',
                '25': '12.5em',
                '26': '13em',
                '27': '13.5em',
                '28': '14em',
                '29': '14.5em',
                '30': '15em',
                '60': '30em',
            },
            zIndex: {
                '-10': -10,
                '-20': -20,
            }
        },
        linearGradientColors: {
            'lightred-darkred': ['#DE686C 0%', '#CB2F33 60%'],
        },

        // Added extra spacing, for extra margins.
        spacing: {
            search: '75%',
            px: '1px',
            '0': '0',
            '1': '0.25rem',
            '2': '0.5rem',
            '3': '0.75rem',
            '4': '1rem',
            '5': '1.25rem',
            '6': '1.5rem',
            '7': '1.75rem',
            '8': '2rem',
            '9': '2.25rem',
            '10': '2.5rem',
            '11': '2.75rem',
            '12': '3rem',
            '14': '3.5rem',
            '16': '4rem',
            '18': '4.5rem',
            '20': '5rem',
            '21': '5.25rem',
            '22': '5.5rem',
            '24': '6rem',
            '25': '6.25rem',
            '26': '6.5rem',
            '27': '6.75rem',
            '28': '7rem',
            '32': '8rem',
            '36': '9rem',
            '40': '10rem',
            '44': '11rem',
            '48': '12rem',
            '52': '11rem',
            '56': '14rem',
            '60': '15rem',
            '64': '16rem',
            '68': '17rem',
            '72': '18rem',
            '76': '19rem',
            '80': '20rem',
            '84': '21rem',
            '88': '22rem',
            '92': '23rem',
            '96': '24rem',
            '100': '25rem',
            '120': '30rem',
            '1/2': '50%',
            '1/3': '33.333333%',
            '2/3': '33.666667%',
            '1/4': '25%',
            '2/4': '50%',
            '3/4': '75%',
            '1/5': '20%',
            '2/5': '40%',
            '3/5': '60%',
            '4/5': '80%',
            '1/6': '16.666667%',
            '2/6': '33.333333%',
            '3/6': '50%',
            '4/6': '66.666667%',
            '5/6': '83.333333%',
            '16/9': '56.25%',
        },
        screens: {
            // Match bootstrap breakpoints
            'sm': '576px',
            'md': '768px',
            'lg': '992px',
            'xl': '1160px',
            'desktop' : '1160px',
        },
    },
    variants: {
    },
    plugins: [
        require('tailwindcss-gradients'),
    ]
};
